import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import gql from "graphql-tag";

export const cornermarkFragment = gql`
  fragment CornermarkFragment on CornerMark {
    id
    cornermarkId
    titleText
    type
    textColor
    mainColor
    secondaryColor
    isGradientColour
    created
  }
`;

export const cornermarkDetailsFragment = gql`
  ${pageInfoFragment}
  fragment CornermarkDetailsFragment on CornerMark {
    id
    cornermarkId
    titleText
    type
    textColor
    mainColor
    secondaryColor
    isGradientColour
    created
    variants(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          sku
          skuName
          isPublished
          product {
            id
            name
          }
          thumbnail {
            url
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
    products(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          isPublished
          productType {
            id
            name
          }
          thumbnail {
            url
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
    categories(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
    collections(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          name
          products {
            totalCount
          }
        }
      }
      pageInfo {
        ...PageInfoFragment
      }
      totalCount
    }
  }
`;
